/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JobSitemapEntry
 */
export interface JobSitemapEntry {
    /**
     * 
     * @type {string}
     * @memberof JobSitemapEntry
     */
    jobLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof JobSitemapEntry
     */
    jobId?: string;
    /**
     * 
     * @type {string}
     * @memberof JobSitemapEntry
     */
    url?: string;
}

/**
 * Check if a given object implements the JobSitemapEntry interface.
 */
export function instanceOfJobSitemapEntry(value: object): value is JobSitemapEntry {
    return true;
}

export function JobSitemapEntryFromJSON(json: any): JobSitemapEntry {
    return JobSitemapEntryFromJSONTyped(json, false);
}

export function JobSitemapEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobSitemapEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'jobLabel': json['jobLabel'] == null ? undefined : json['jobLabel'],
        'jobId': json['jobId'] == null ? undefined : json['jobId'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function JobSitemapEntryToJSON(value?: JobSitemapEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobLabel': value['jobLabel'],
        'jobId': value['jobId'],
        'url': value['url'],
    };
}

